import { createContext, useContext } from 'react';
import type { DataProvider } from './types';

export const DataContext = createContext<DataProvider<unknown, unknown> | null>(
  null,
);

// FIXME: There is no guarentee that the DataContext T will be the T specified here.
export const useDataProvider = <T, TExtra = never>(): DataProvider<
  T,
  TExtra
> => {
  const context = useContext(DataContext) as DataProvider<T, TExtra> | null;
  if (!context) {
    throw new Error(
      'useDataProvider must be used within a DataContext Provider',
    );
  }

  return context;
};
